"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var theme_1 = require("../../../theme");
var theme_ui_1 = require("theme-ui");
exports.ContainerBox = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(theme_ui_1.Container, { sx: {
            alignItems: "center",
            maxWidth: ["none", "32rem"],
            p: "1.25rem",
            m: ["auto", "1.25rem auto"],
            width: ["100%", "auto"],
            background: theme_1.theme.colors.bluePanel,
            boxShadow: "0 0.1875rem 0.1875rem 0 #071820, inset 0 0.0625rem 0.0625rem 0 rgba(145,181,197,0.75)",
            position: ["absolute", "relative"],
            transition: "width 0.25s",
            contentVisibility: "auto",
            ":before": {
                boxShadow: "0 0.0625rem 0.125rem 0 rgba(145,181,197,0.75), inset 0 0.1875rem 0.1875rem 0 #071820",
                content: '""',
                height: "calc(100% - .875rem)",
                left: ["0px", ".4375rem"],
                pointerEvents: "none",
                position: "absolute",
                top: ".4375rem",
                width: ["100%", "calc(100% - .875rem)"]
            }
        } }, children));
};
